/* eslint-disable @typescript-eslint/no-empty-interface */
import { Injectable } from '@angular/core';
import { JSONRPCService } from '@s8l/client-tree-lib';

import { serviceURL } from './service';

export type Instant = any;
export type Duration = any;

export interface NodeAuditFetchRequest {
  username?: string;
  action?: string;
  resource?: string;
  value?: string;
  api?: boolean;
  offset?: number;
  limit?: number;
}

export interface NodeAuditRecord {
  uuid?: string;
  username?: string;
  resource?: string;
  action?: string;
  value?: any;
  timestamp?: Instant;
}

@Injectable({
  providedIn: 'root'
})
export class StreamsServerService extends JSONRPCService {
  public async auditFetch(params: NodeAuditFetchRequest): Promise<NodeAuditRecord[]> {
    return this.message(serviceURL('STREAMS_SERVER', '/node/audit'), 'fetch', params);
  }
}
